module.exports = __webpack_public_path__ + "67282a7bc14d83735f595b34aafe8235.png";